import { InternalService } from "@services";

const state = {
    subscription: {},
    seatsUsed: -1,
};

const getters = {
    noDefaultPaymentMethod: (state) => state.subscription.noDefaultPaymentMethod,

    paymentActionRequired: (state) => state.subscription.paymentActionRequired,

    corruptSubscription: (state) => state.subscription.corruptSubscription,

    needsUpdateSubscription: (state) => state.subscription.needsUpdateSubscription,

    expired: (state) => state.subscription.expired,

    internal: (state) => state.subscription.internal,

    external: (state) => state.subscription.external,

    seats: (state) => state.subscription.seats,

    seatsUsed: (state) => state.seatsUsed,
};

const mutations = {
    setSeatsUsed(state, seatsUsed) {
        state.seatsUsed = seatsUsed;
    },

    incSeatsUsed(state, v) {
        if (!this.internal) {
            state.seatsUsed += v;
        }
    },

    decSeatsUsed(state, v) {
        if (!this.internal) {
            state.seatsUsed -= v;
        }
    },
};

const actions = {
    checkHeartbeat({ state }) {
        return InternalService.adminHeartbeat()
            .then((r) => {
                state.subscription = r.data.subscription;
            })
            .catch(() => {
                // Keep planner shell usable even if heartbeat is unavailable.
                state.subscription = {};
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
